// ResourceConfig.js - 资源配置文件
// 集中管理所有需要加载的资源

import { EQUIPMENT_ICONS } from './equipmentIcons.generated.js';

export const RESOURCE_CONFIG = {
    // 玩家头像
    playerAvatars: [
        { key: 'player_avatar1', path: 'assets/player/主角1.png' },
        { key: 'player_avatar2', path: 'assets/player/主角2.png' },
        { key: 'player_avatar3', path: 'assets/player/主角3.png' }
    ],
    
    // 装备展示图片（用于装备菜单中的人体剪影）
    equipmentSilhouettes: [
        { key: 'equipment_silhouette_p1', path: 'assets/player/p1.png' },
        { key: 'equipment_silhouette_p2', path: 'assets/player/p2.png' },
        { key: 'equipment_silhouette_p3', path: 'assets/player/p3.png' }
    ],
    
    // 装备图标（assets/equipment/{itemId}.png，由 tools/generate_equipment_icons.py 生成）
    equipmentIcons: EQUIPMENT_ICONS,
    
    // 玩家精灵图（512x512 精灵表，4x4 网格，每帧 128x128）
    players: [
        { key: 'player1', path: 'assets/images/主角1.png', width: 128, height: 128, flipLR: true },
        { key: 'player2', path: 'assets/images/主角2.png', width: 128, height: 128 },
        { key: 'player3', path: 'assets/images/主角3.png', width: 128, height: 128, flipLR: true },
        { key: 'player4', path: 'assets/images/龙女.png', width: 32, height: 32 }
    ],
    
    // NPC精灵图（32x32）
    npcs: [
        { key: 'npc_guide', path: 'assets/images/佛像.png', width: 32, height: 32 },
        { key: 'npc_civilian1', path: 'assets/images/平民男1.png', width: 32, height: 32 },
        { key: 'npc_civilian2', path: 'assets/images/平民男2.png', width: 32, height: 32 },
        { key: 'npc_civilian3', path: 'assets/images/平民男3.png', width: 32, height: 32 },
        { key: 'npc_civilian4', path: 'assets/images/平民男4.png', width: 32, height: 32 },
        { key: 'npc_civilian_woman1', path: 'assets/images/平民女1.png', width: 32, height: 32 },
        { key: 'npc_civilian_woman2', path: 'assets/images/平民女2.png', width: 32, height: 32 },
        { key: 'npc_civilian_woman3', path: 'assets/images/平民女3.png', width: 32, height: 32 },
        { key: 'npc_civilian_woman4', path: 'assets/images/平民女4.png', width: 32, height: 32 },
        { key: 'npc_civilian_woman5', path: 'assets/images/尼娜.png', width: 32, height: 32 },
        { key: 'npc_oldman', path: 'assets/images/老者.png', width: 32, height: 32 },
        { key: 'npc_warrior1', path: 'assets/images/勇士1.png', width: 32, height: 32 },
        { key: 'npc_warrior2', path: 'assets/images/勇士2.png', width: 32, height: 32 },
        { key: 'npc_warrior3', path: 'assets/images/勇士3.png', width: 32, height: 32 },
        { key: 'npc_warrior4', path: 'assets/images/粗鲁勇士.png', width: 32, height: 32 },
        { key: 'npc_qigongshi1', path: 'assets/images/气功师.png', width: 32, height: 32 },
        { key: 'npc_merchant1', path: 'assets/images/商人1.png', width: 32, height: 32 },
        { key: 'npc_merchant2', path: 'assets/images/商人2.png', width: 32, height: 32 },
        { key: 'npc_shopkeeper1', path: 'assets/images/商店员1.png', width: 32, height: 32 },
        { key: 'npc_shopkeeper2', path: 'assets/images/商店员2.png', width: 32, height: 32 }
    ],
    
    // 战车精灵图（512x512 精灵表，4x4 网格，每帧 128x128）
    tanks: [
        { key: 'tank1', path: 'assets/images/坦克1.png', width: 128, height: 128 },
        { key: 'tank2', path: 'assets/images/坦克2.png', width: 128, height: 128 },
        { key: 'tank3', path: 'assets/images/坦克3.png', width: 128, height: 128 },
        { key: 'tank4', path: 'assets/images/坦克4.png', width: 128, height: 128 },
        { key: 'tank5', path: 'assets/images/坦克5.png', width: 128, height: 128 },
        { key: 'tank6', path: 'assets/images/坦克6.png', width: 128, height: 128 },
        { key: 'tank7', path: 'assets/images/坦克7.png', width: 128, height: 128 },
        { key: 'tank8', path: 'assets/images/坦克8.png', width: 128, height: 128 },
        { key: 'tank9', path: 'assets/images/坦克9.png', width: 128, height: 128 },
        { key: 'tank10', path: 'assets/images/坦克10.png', width: 128, height: 128 },
        { key: 'tank11', path: 'assets/images/坦克11.png', width: 128, height: 128 },
        { key: 'transport', path: 'assets/images/阿帕奇.png', width: 64, height: 59.5 }
    ],
    // 敌人精灵图
    enemies: [
        { key: 'dog', path: 'assets/images/战狗.png', width: 32, height: 32 },
        { key: '胖达', path: 'assets/images/胖达.png', width: 32, height: 32 }
    ],
    // 战斗特效精灵图
    battleEffects: [
        { key: 'rifle', path: 'assets/battle/effect/rifle.png', width: 128, height: 128 },
        { key: 'laser_canon', path: 'assets/battle/effect/激光炮.png', width: 128, height: 128 },
        { key: 'laser', path: 'assets/battle/effect/laser.png', width: 128, height: 128 },
        { key: 'cannon', path: 'assets/battle/effect/cannon.png', width: 190, height: 162.5 }
    ],
    
    // 启动必需音频（其余 BGM/音效按需加载）
    essentialAudio: [
        { key: 'start_bgm', path: 'assets/audio/01.mp3' },
        { key: 'into', path: 'assets/sound/into.wav' }
    ],
    
    // 背景音乐
    bgm: [
        { key: 'start_bgm', path: 'assets/audio/01.mp3' },
        { key: 'world_bgm1', path: 'assets/audio/04.mp3' },
        { key: 'world_bgm2', path: 'assets/audio/09.mp3' },
        { key: 'encounter_bgm', path: 'assets/audio/05.mp3' },
        { key: 'battle_bgm', path: 'assets/audio/06.mp3' },
        { key: 'victory_bgm', path: 'assets/audio/07.mp3' },
        { key: 'attck_bgm', path: 'assets/audio/20.mp3' },
        { key: 'boss_bgm', path: 'assets/audio/21.mp3' },
        { key: 'town_bgm', path: 'assets/audio/03.mp3' },
        { key: 'sleep_bgm', path: 'assets/audio/25.mp3' },
        { key: 'cave_bgm', path: 'assets/audio/08.mp3' },
        { key: 'level_up_bgm', path: 'assets/audio/29.mp3' }
    ],
    
    // 音效
    soundEffects: [
        { key: 'into', path: 'assets/sound/into.wav' },
        { key: 'fall', path: 'assets/sound/fall.wav' },
        { key: 'inVehicle', path: 'assets/sound/inVehicle.wav' },
        { key: 'obstacle', path: 'assets/sound/obstacle.wav' },
        { key: 'laser_canon_attack', path: 'assets/sound/laser_canon.wav' },
        { key: 'laser_attack', path: 'assets/sound/laser.wav' },
        { key: 'rifle_attack', path: 'assets/sound/rifle_attack.wav' },
        { key: 'cannon_attack', path: 'assets/sound/45mm.wav' },
        { key: 'beam_attack', path: 'assets/sound/beam.wav' },
        { key: 'default_attack', path: 'assets/sound/default_attack.wav' },
        { key: 'missile_attack', path: 'assets/sound/missile.wav' }
    ],
    
    // JSON数据
    // 注意：key用于从缓存读取数据，应该与JSON文件中的"key"字段或sceneConfig中的mapKey匹配
    jsonData: [
        { key: 'world_meta', path: 'assets/data/world_meta.json' },
        { key: 'chunk_1_4', path: 'assets/data/chunks/chunk_1_4.json' },
        { key: 'map_rado', path: 'assets/data/rado_town.json' },  // JSON中的key是"拉多镇"，但这里用'map_rado'作为缓存key
        { key: 'map_mack', path: 'assets/data/mack_town.json' },
        { key: 'map_bar_1', path: 'assets/data/bar_1.json' },
        { key: 'map_human_1', path: 'assets/data/human_1.json' },
        { key: 'map_hotel_1', path: 'assets/data/hotel_1.json' },  // JSON中的key是"旅馆1"，但这里用'map_hotel_1'作为缓存key
        { key: 'map_hotel_2', path: 'assets/data/hotel_2.json' },  // JSON中的key是"旅馆2"，但这里用'map_hotel_2'作为缓存key
        { key: 'map_tank_center_1', path: 'assets/data/tank_center_1.json' },
        { key: '洞穴1', path: 'assets/data/cave_1.json' },  // JSON中的key是"拉多南山洞"，但这里用'洞穴1'作为缓存key
        { key: '洞穴2', path: 'assets/data/cave_2.json' },
        { key: '拉多北山洞', path: 'assets/data/cave_north.json' },
        { key: 'enemies', path: 'assets/data/enemies.json' },
        { key: 'items', path: 'assets/data/items.json' },
        { key: 'vehicle_equipment', path: 'assets/data/vehicle_equipment.json' }
    ]
};

